import { Injectable } from '@angular/core';
import { Cxcdettmpamortiza } from "../cxcinterfaces/cxcdettmpamortiza";
import { Cxcenctmpamortiza } from "../cxcinterfaces/cxcenctmpamortiza";


import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';

@Injectable({
  providedIn: 'root'
})
export class CxctmpamortizacionService {

  public way: string;

  public enctmpamortiza: Cxcenctmpamortiza[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  public _dettmpamortiza: Cxcdettmpamortiza[];
  get dettmpamortiza(): Cxcdettmpamortiza[] {
    return this._dettmpamortiza;
  }

  set dettmpamortiza(value: Cxcdettmpamortiza[]) {
    this._dettmpamortiza = value;
  }

  constructor(
    private http: HttpClient, public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario, private confIniciales: ConfInicialesService,
    private message: MessageService, private utilitariosService: UtilitariosService

  ) {
    this.way = sessionStorage.getItem('way');
  }

  ejecutarproceso(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/74dccf755db654000000', {
      elementos: {
        p_capital: this.utilitariosService.redondear(item.CAPITAL, 2),
        p_dia_gra: this.utilitariosService.redondear(item.DIA_GRA, 2),
        p_tasa: this.utilitariosService.redondear(item.TASA, 2),
        p_plazo: this.utilitariosService.redondear(item.PLAZO, 2),
        p_fecini: item.FECINI,
        p_cli_codigo: item.CLI_CODIGO,
        p_encfac_numero: item.ENCFAC_NUMERO,
        p_com_codigo: '01',
        p_usuidentificacion: this.usuario.identificacion

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultartmpamortiza() {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/cc5f9eaf55db680000000', {
      elementos: {
        p_usuidentificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarenccuota(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/20ebbb6a75d8d00000', {
      elementos: {
        p_enccuota_codigo: item.ENCCUOTA_CODIGO,
        p_com_codigo: '01',
        p_cli_codigo: item.CLI_CODIGO,
        p_encfac_numero: item.ENCFAC_NUMERO,
        p_capital: Number(item.CAPITAL),
        p_cuota_mensual: Number(item.CUOTA_MENSUAL),
        p_cuota_gracia: Number(item.CUOTA_GRACIA),
        p_dias_gracia: Number(item.DIA_GRA),
        p_tasa: Number(item.TASA),
        p_plazo: Number(item.PLAZO),
        p_fecini: item.FECINI,
        p_usuidentificacion: this.usuario.identificacion,
        p_GAR_ID: item.GAR_ID,
        p_ENCCUO_TIPO: item.ENCCUO_TIPO,
        p_ENCCUO_CUOORIGEN: item.ENCCUOTA_CUOORIGEN,
        

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertardetcuota(arreglodet) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/20ebbb6a6bbad00000', {
      elementos: {
        arreglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getenccuota(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/41dd75d8cf63a8', {
      elementos: {
        p_ENCCUO_CODIGO: numero
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetcuota(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/41dd6bbacf63a8', {
      elementos: {
        p_ENCCUO_CODIGO: numero
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetdocumento(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/41dd6bbadc338c00000', {
      elementos: {
        p_ENCCUO_CODIGO: numero
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarfacturas(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/1075ddb56dea670000000000000', {
      elementos: {
        p_enccuota_codigo: numero,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(numero,codorigen) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/eacad2bab7db680000000', {
      elementos: {
        p_enccuota_codigo: numero,
        p_com_codigo: '01',
        p_ENCCUO_CUOORIGEN:codorigen
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  reversarfacturas(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/dbbeedf15b7a98000000', {
      elementos: {
        p_enccuota_codigo: numero,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  obtenerNombreCli(cliCodigo: string): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/ventas/guiaremision/nppame3erx8ny7h', {
      elementos: {
        CLI_CODIGO: cliCodigo
      },
    }, this.confIniciales.httpOptions());
  }
  getgarante(garid) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/663d7ec15b55fc0', {
      elementos: {
        p_garante: garid,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarasiento(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/83aeedab6ae4a000000000000', {
      elementos: {
        p_enccuota_codigo: numero,
        p_com_codigo: '01',
        p_tipdia_codigo: 'AIG',
        p_origen: 'CXC',
        p_usuario: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  aplicarefinacia(item,valor) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/acd64c56f6e7c80000000', {
      elementos: {
        p_enccuota_codigo: item.ENCCUOTA_CODIGO,
        p_fechaact: item.FECHA,
        p_ab_cap: Number(valor),
        p_ab_cap_nu: Number(item.N_NOMINAL),
        p_com_codigo: item.COM_CODIGO,
        p_usuidentificacion: this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultacis(trncobro) {
    return this.http.post<any[]>(this.way + '/cxc/cxctmpamortiza/3317e7abd5325c', {
      elementos: {
        p_TRNCOBRO_NRODOC:trncobro,
        p_com_codigo:'01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
